import { render, staticRenderFns } from "./ManifestFilters.vue?vue&type=template&id=3a2328d8"
import script from "./ManifestFilters.vue?vue&type=script&lang=ts"
export * from "./ManifestFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports